import PropTypes from "prop-types";
import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

import CreateButton from "components/CreateButton";
import CastNumberSelect from "components/CastNumberSelect";
import TemplateGroupPresenter from "presenters/TemplateGroupPresenter";

const Container = styled("div")(() => ({
  flex: 1,
  "& div": {
    display: "block",
    marginRight: "auto",
    marginLeft: "auto",
  },
  "& button": {
    display: "block",
    margin: "auto",
  },
}));

const Actions = ({ loading, templateGroup }) => {
  return (
    <Container>
      <Box sx={{ display: "block", marginBottom: 2, maxWidth: 220 }}>
        <CastNumberSelect templateGroup={templateGroup} fullWidth />
      </Box>
      <CreateButton loading={loading} buttonText="Create Invite" />
    </Container>
  );
};

Actions.propTypes = {
  loading: PropTypes.bool,
  templateGroup: TemplateGroupPresenter.shape(),
};

export default Actions;
